export default __webpack_public_path__ + "static/media/Close.5d9503cb.svg";